module.exports = __webpack_public_path__ + "img/logo4.1bc1769f.jpg";